import { DELETE, GET, PATCH, POST } from "../API";

export const getMembersAPICall = (
    projectId,
    page,
    itemsPerPage,
    search,
    onSuccess,
    onError,
    role
) => {
    const params = new URLSearchParams();
    if (page) params.append('page', page);
    if (itemsPerPage) params.append('items_per_page', itemsPerPage);
    if (search) params.append('search', search);
    if (role && role !== 'all') params.append('role', role);

    const url = process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/members${params.toString() ? '?' + params.toString() : ''}`;

    GET(
        url,
        onSuccess,
        onError
    );
};

export const inviteMembersAPICall = (
    projectId,
    members,
    onSuccess,
    onError
) => {
    const data = {
        members: members.map(member => {
            const mapped = {
                email: member.email,
                role: member.role,
            };

            if (member.role === "member" && member.product_slugs?.length > 0) {
                mapped.product_slugs = member.product_slugs;
            }

            return mapped;
        }),
    };

    POST(
        process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/members/invite`,
        data,
        onSuccess,
        onError
    );
};

export const removeMemberAPICAll = (
    projectId,
    memberId,
    onSuccess,
    onError
) => {

    DELETE(
        process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/members/${memberId}/remove`,
        onSuccess,
        onError
    );


};

export const changeMemberRoleAPICall = (
    projectId,
    memberId,
    role,
    productSlugs,
    onSuccess,
    onError
) => {
    const data = {
        role: role,
    };

    if (role === "member" && productSlugs?.length > 0) {
        data.product_slugs = productSlugs;
    }
    PATCH(
        process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/members/${memberId}/change_role`,
        data,
        onSuccess,
        onError
    );
};